<template>
    <input type="email" :value="value" class="form-control new-design email-icon" :required="required" :placeholder="placeholder"
           @input="handleInput">
</template>

<script>
export default {
    name: "EmailInput",
    props: ['value', 'placeholder', 'required'],
    methods: {
        handleInput(event) {
            this.$emit('input', event.target.value)
        },
    }
}
</script>

<style scoped>
.form-control.new-design::placeholder {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.form-control.new-design {
    padding: 16px;
    border: 1px solid #E0E2E5;
    border-radius: 8px;
    box-sizing: border-box;

    height: 56px;

    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
}

.email-icon {
    background-repeat: no-repeat;
    background-position: 15px 17px;
    padding-left: 45px !important;
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='16' viewBox='0 0 20 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20 2C20 0.9 19.1 0 18 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2ZM18 2L10 7L2 2H18ZM18 14H2V4L10 9L18 4V14Z' fill='%232E4051'/%3E%3C/svg%3E");
}
</style>